(function () {
  function normalizeUrl(url) {
    if (!url) return "";
    if (url.startsWith("//")) return "https:" + url;
    return url;
  }

  function getProductJsonOnce() {
    // cache on window so it persists across calls
    if (window.__paProductJson && Array.isArray(window.__paProductJson.variants)) {
      return window.__paProductJson;
    }

    const candidates = [
      'script[type="application/json"][data-product-json]',
      'script[type="application/json"][id*="ProductJson"]',
      'script[type="application/json"][id*="product-json"]',
      'script[type="application/json"][id*="ProductJson-"]'
    ];

    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (!el) continue;
      try {
        const data = JSON.parse(el.textContent.trim());
        if (data && Array.isArray(data.variants)) {
          window.__paProductJson = data;
          return data;
        }
      } catch (e) {}
    }

    if (window?.meta?.product && Array.isArray(window.meta.product.variants)) {
      window.__paProductJson = window.meta.product;
      return window.meta.product;
    }
    if (window?.Shopify?.product && Array.isArray(window.Shopify.product.variants)) {
      window.__paProductJson = window.Shopify.product;
      return window.Shopify.product;
    }

    return null;
  }

  function optionIndexFromDataIndex(dataIndex) {
    const m = String(dataIndex || "").match(/option(\d+)/i);
    if (!m) return 0;
    return Math.max(0, parseInt(m[1], 10) - 1);
  }

  function findVariantImage(variant) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant?.featured_image) return variant.featured_image;
    if (variant?.image?.src) return variant.image.src;
    if (variant?.image) return variant.image;
    if (variant?.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    return "";
  }

  // Build a lookup table once: key = `${optionIndex}::${optionValue}`
  function buildImageMapOnce(product) {
    if (window.__paVariantImageMap && window.__paVariantImageMap.__forProductId === product.id) {
      return window.__paVariantImageMap;
    }

    const map = new Map();
    (product.variants || []).forEach((v) => {
      const img = normalizeUrl(findVariantImage(v));
      if (!img) return;
      const opts = v.options || [];
      opts.forEach((optVal, idx) => {
        if (!optVal) return;
        map.set(`${idx}::${String(optVal)}`, img);
      });
    });

    // stash
    map.__forProductId = product.id;
    window.__paVariantImageMap = map;
    return map;
  }

  function syncProductPageChips(root) {
    const product = getProductJsonOnce();
    if (!product) return;

    const imgMap = buildImageMapOnce(product);

    const scope = root || document;
    const wraps = scope.querySelectorAll(
      ".product__color-chips.dynamic-variant-input-wrap[data-product-option]"
    );

    wraps.forEach((wrap) => {
      const optionIndex = optionIndexFromDataIndex(wrap.getAttribute("data-index"));
      const buttons = wrap.querySelectorAll(
        "button.dynamic-variant-button.product__chip[data-option-value]"
      );

      buttons.forEach((btn) => {
        const value = btn.getAttribute("data-option-value");
        if (!value) return;

        const imgUrl = imgMap.get(`${optionIndex}::${String(value)}`);
        if (!imgUrl) return;

        const icon = btn.querySelector(".variant-icon-img");
        if (!icon) return;

        // Avoid re-setting style if already correct (reduces repaint)
        const nextBg = `url("${imgUrl}")`;
        if (icon.dataset.bg === nextBg) return;

        icon.style.backgroundImage = nextBg;
        icon.dataset.bg = nextBg;
      });
    });
  }

  // schedule updates efficiently (no spam)
  let scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncProductPageChips(document);
    });
  }

  function preloadChipImagesAggressive() {
  const product = getProductJsonOnce();
  if (!product) return;

  const imgMap = buildImageMapOnce(product);

  const buttons = document.querySelectorAll(
    ".product__color-chips.dynamic-variant-input-wrap[data-product-option] button.dynamic-variant-button.product__chip[data-option-value]"
  );

  const urls = new Set();
  buttons.forEach((btn) => {
    const wrap = btn.closest(".dynamic-variant-input-wrap[data-index]");
    if (!wrap) return;

    const optionIndex = optionIndexFromDataIndex(wrap.getAttribute("data-index"));
    const value = btn.getAttribute("data-option-value");
    if (!value) return;

    const u = imgMap.get(`${optionIndex}::${String(value)}`);
    if (u) urls.add(u);
  });

  // 1) High-priority preload hints (browser fetches sooner)
  const head = document.head || document.getElementsByTagName("head")[0];
  urls.forEach((u) => {
    if (!u) return;

    // Avoid duplicating preload tags
    const already = head.querySelector(`link[rel="preload"][as="image"][href="${CSS.escape(u)}"]`);
    if (!already) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = u;
      // If your CDN uses crossOrigin, uncomment:
      // link.crossOrigin = "anonymous";
      head.appendChild(link);
    }
  });

  // 2) Fetch + force decode now (so switching doesn’t wait)
  urls.forEach((u) => {
    if (!u) return;

    const img = new Image();
    img.fetchPriority = "high";      // supported in modern Chrome
    img.decoding = "sync";           // decode sooner (best-effort)
    img.loading = "eager";
    img.src = u;

    // Force decode (best-effort; older browsers will just ignore)
    if (img.decode) {
      img.decode().catch(() => {});
    }
  });

  // 3) Also warm HTTP cache via fetch (sometimes helps more than Image)
  // (Safe for 3 small images)
  urls.forEach((u) => {
    try {
      fetch(u, { mode: "no-cors", cache: "force-cache" }).catch(() => {});
    } catch (e) {}
  });
}

  function boot() {

    document.addEventListener("click", (e) => {
  const btn = e.target && e.target.closest
    ? e.target.closest("button.dynamic-variant-button.product__chip")
    : null;
  if (!btn) return;

  // immediate paint: set icon NOW
  const wrap = btn.closest(".dynamic-variant-input-wrap[data-index]");
  const product = getProductJsonOnce();
  if (wrap && product) {
    const imgMap = buildImageMapOnce(product);
    const optionIndex = optionIndexFromDataIndex(wrap.getAttribute("data-index"));
    const value = btn.getAttribute("data-option-value");
    const imgUrl = value ? imgMap.get(`${optionIndex}::${String(value)}`) : "";
    const icon = btn.querySelector(".variant-icon-img");
    if (imgUrl && icon) {
      const nextBg = `url("${imgUrl}")`;
      icon.style.backgroundImage = nextBg;
      icon.dataset.bg = nextBg;
    }
  }

  scheduleSync();
}, true);

    // run ASAP (don’t wait for images)
    scheduleSync();
    // preload immediately so first click is instant
    preloadChipImagesAggressive();

    // run when the select changes
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (t && t.matches("select.dynamic-variant-input")) scheduleSync();
    });

    // run when a chip is clicked (instant feedback)
    document.addEventListener("click", (e) => {
      const btn = e.target && e.target.closest
        ? e.target.closest("button.dynamic-variant-button.product__chip")
        : null;
      if (btn) scheduleSync();
    }, true);

    // mutation observer throttled to RAF
    const mo = new MutationObserver(() => scheduleSync());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();